import { z } from 'zod';
import { getCityById } from '../geo/cities';
import { SPORT_IDS } from '../sports';
import type { SportId } from '../types/sport';

const sport = z.enum(SPORT_IDS as [SportId, ...SportId[]]);
export const cityPageParamsSchema = z.object({
  cityId: z.string().max(100).refine((id) => !!getCityById(id), 'Неизвестный город'),
});
export const cityGamesQuerySchema = z.object({ sport: sport.optional(), limit: z.coerce.number().int().min(1).max(6).default(6) });
export const cityPlayRequestSchema = z.object({ sport });
export const createCityPlayRequestSchema = cityPlayRequestSchema.extend({
  landingPath: z.string().max(240).regex(/^\/gde-poigrat\/[a-z_]+\/[a-z0-9-]+$/).optional(),
}).strict();
export const cancelCityPlayRequestSchema = cityPlayRequestSchema.extend({ requestId: z.string().uuid() });

export interface CityGame {
  id: string;
  title: string | null;
  sport: string;
  date: string;
  time: string;
  timezone: string;
  locationText: string | null;
  orgName: string | null;
  joinedCount: number;
  spotsLeft: number | null;
}
export interface CityGames {
  cityId: string;
  games: CityGame[];
}
export interface CityPlayRequest {
  id: string;
  cityId: string;
  sport: string;
  expiresAt: string;
}
